module.exports = __webpack_public_path__ + "static/media/S1_00023.079f966f.jpg";